
import "./Employees.css";
import React, { useState, useEffect } from "react";
import { getAllUsers } from "../../api";
import { useNavigate } from "react-router-dom";
import { useGlobalContext } from "../../context";
import DeleteIcon from '@mui/icons-material/Delete';
import BorderColorRoundedIcon from '@mui/icons-material/BorderColorRounded';
import Loading from "../../Components/Loading/Loading";
import Header from "../../Components/Header/Header";
import DeleteUser from "./DeleteUser";

function Employees() {

    const {
        findRole,
        setLoading
    } = useGlobalContext()

    const [users, setUsers] = useState<Array<any>>([]);
    const [concretUser, setConcretUser] = useState<any>();
    const [openDeleteModal, setOpenDeleteModal] = useState<boolean>(false);
    const navigate = useNavigate();

    const gettingUsersData = async () => {
        setLoading(true);
        try {
            const userData = await getAllUsers();
            if (userData)  setUsers(userData.data);
        }
        catch (err) {
            console.log(err);
        }
        setLoading(false);
    }

    useEffect(() => {
        gettingUsersData().then(r => r);
    }, [])

    const createUser = () => {
        navigate("/create-user");
    }

    const openDeleteWindow = (user: any) => {
        setConcretUser(user);
        setOpenDeleteModal(true);
    }

    const goToEditUser = (user: any): void => {
        navigate("/edit-user", { state: user.id });
    }

    return (
        <div className = "Employees">
            <Header/>
            <div className = "allClients-container">
                <div
                    className = "allClients-header"
                    style = {{
                        marginBottom: "50px"
                    }}
                >
                    <div className = "allClients-header-heading">
                        <h2> EMPLOYEES </h2>
                    </div>
                    {
                        findRole("PX") === "ADMIN" &&
                            <div className = "allClients-header-btns">
                                <button
                                    onClick = { createUser }
                                >
                                    Create a User
                                </button>
                            </div>
                    }
                </div>
                <div className = "allUsers-container-block">
                    <table className = "allUser-table">
                        <thead>
                            <tr>
                                <th> N </th>
                                <th> Email </th>
                                <th className = "employee-position-data"> Position </th>
                                <th> { findRole("PX") === "ADMIN" ? "Action" : "" } </th>
                            </tr>
                        </thead>
                        <tbody>
                        {
                            users.map((user: any, index: number) =>
                                <tr key = { user.id }>
                                    <td>{ index + 1 }</td>
                                    <td className = "employee-username-data">{ user.username }</td>
                                    <td className = "employee-position-data">{ user.permissions?.map((position: any) => <span className = "user-position-text">{ position.project + " " + "-" + " " + position.role.toLowerCase() + "," }</span>) }</td>
                                    <td className = "employee-actions-data">
                                        {
                                            findRole("PX") === "ADMIN" &&
                                                <BorderColorRoundedIcon
                                                    titleAccess = "Edit"
                                                    className = "materialIcon"
                                                    onClick = { () => goToEditUser(user) }
                                                />
                                        }
                                        {
                                            findRole("PX") === "ADMIN" &&
                                                <DeleteIcon
                                                    titleAccess = "Delete"
                                                    className = "materialIcon"
                                                    onClick = { () => openDeleteWindow(user) }
                                                />
                                        }
                                    </td>
                                </tr>
                            )
                        }
                        </tbody>
                    </table>
                </div>
            </div>
            {
                concretUser &&
                    <DeleteUser
                        concretUser = { concretUser }
                        setConcretUser = { setConcretUser }
                        openDeleteModal = { openDeleteModal }
                        setOpenDeleteModal = { setOpenDeleteModal }
                        gettingUsersData = { gettingUsersData }
                    />
            }
            <Loading/>
        </div>
    )
}

export default Employees
